/**
 * Axis label for the live / LTM point on stock charts: the current year with an
 * apostrophe ("'26"), matching the FY labels ('24, '25, '26E) instead of "Cur".
 * If the latest fiscal year already carries that label (FY ended this calendar
 * year), fall back to "Now" so the two points never share one category key.
 */
export function currentPeriodLabel(takenLabels: Iterable<string>, now: Date = new Date()): string {
  const yy = `'${String(now.getFullYear()).slice(-2)}`;
  for (const label of takenLabels) {
    if (label === yy) return 'Now';
  }
  return yy;
}
